import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import {
    menuWrapper,
    open,
    menu,
    menuItem,
    link,
    active,
    menuItemPrimary,
} from './menu.module.scss';
import { FaArrowRight } from 'react-icons/fa';

const Menu = ({ isOpen, toggleMenuFn }) => {
    return (
        <div
            className={`${menuWrapper} ${isOpen ? open : ''}`}
            aria-label="Navigation">
            <nav className={menu} role="navigation" itemType="https://schema.org/SiteNavigationElement">
                <h3 className={menuItem}>
                    <Link
                        to="/calculator"
                        className={`${link}`}
                        partiallyActive={ true }
                        activeClassName={ `${active}` }
                        onClick={toggleMenuFn}>
                        Free Payroll Calculators
                    </Link>
                </h3>
                <h3 className={menuItem}>
                    <Link
                        to="/payroll-resources"
                        className={`${link}`}
                        partiallyActive={ true }
                        activeClassName={ `${active}` }>
                        Payroll Resources
                    </Link>
                </h3>
                <h3 className={menuItem}>
                    <Link
                        to="/small-business-guide"
                        className={`${link}`}
                        partiallyActive={ true }
                        activeClassName={ `${active}` }>
                        Small Business
                    </Link>
                </h3>
                <h3 className={menuItem}>
                    <Link
                        to="/insights"
                        className={`${link}`}
                        partiallyActive={ true }
                        activeClassName={ `${active}` }>
                        Insights
                    </Link>
                </h3>
                <h3 className={`${menuItem} ${menuItemPrimary}`}>
                    <Link
                        to="/"
                        className={`${link} icon-animate-pan-x align-icon-wrapper`}
                        activeClassName={ `${active}` }>
                        Run your own payroll
                        <span className="align-icon"><FaArrowRight /></span>
                    </Link>
                </h3>
            </nav>
        </div>
    );
};

Menu.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleMenuFn: PropTypes.func.isRequired,
};

export default Menu;
